import React from "react";

type TCurrencyInputProps = {
  name: string;
  label?: string;
  placeholder?: string;
  value?: number | string;
  onChange?: (value: number | string) => void;
  required?: boolean;
  className?: string;
  disabled?: boolean;
};

const formatWithCommas = (val: string | number): string => {
  if (val === "" || val === undefined || val === null) return "";
  const num =
    typeof val === "string" ? val.replace(/[^0-9]/g, "") : String(val);
  if (!num) return "";
  return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const CurrencyInput = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  required = false,
  className = "",
  disabled,
}: TCurrencyInputProps) => {
  const displayValue = formatWithCommas(value ?? "");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^0-9]/g, "");
    if (onChange) {
      onChange(raw ? Number(raw) : "");
    }
  };

  return (
    <div className="mb-2">
      {label && (
        <label className="block text-blue-primary font-medium text-sm mb-2">
          {label} {required && <span className="text-red-500 text-sm">*</span>}
        </label>
      )}
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
          ₦
        </span>
        <input
          type="text"
          inputMode="numeric"
          name={name}
          value={displayValue}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`
            w-full
            pl-7
            pr-4
            py-3
            text-gray-600
            bg-white
            shadow-sm
            border
            border-soft-200
            rounded-lg
            focus:outline-none
            focus:border-bnp-cyan
            transition-colors
            h-12
            ${className}
          `}
        />
      </div>
    </div>
  );
};

export default CurrencyInput;
